import React from 'react';
import { signOut } from 'firebase/auth';
import { auth } from '../../firebase/firebaseConfig';
import {
  AccountPortalShell,
  HCard,
  HearthIcon,
  SerifHeading,
  SectionLabel,
  HSecondaryButton,
  HGhostButton,
} from '../h';
import { ShippedSummary } from './ShippedSummary';

/* v9 mockups 1.6 (single Hearth) and 1.7 (multiple Hearths).

   Shown when the customer has confirmed their addresses AND we've flipped
   `preparingForShipping = true` on the account (admin tool). At that point
   the addresses are locked and the user is just waiting for the parcel.

   Note (backend gap): /user/userinfo currently returns shippingAddressAtOrder
   but not the per-Hearth `shippingAddresses` array that /confirmShippingAddresses
   wrote. Until that's exposed, multi-Hearth users see the order-time address
   for Hearth 1 only. Tracked in FEAT-133-BACKEND-NOTES.md. */
function PreparingForShipping({
  email,
  numOfFamilies = 1,
  shippingAddressAtOrder,
  nameFromServer,
  shippingAddresses,
}) {
  const handleSignOut = async () => {
    try {
      await signOut(auth);
    } catch (error) {
      console.error('Sign out error', error);
    }
  };

  return (
    <AccountPortalShell
      rightSlot={
        <HGhostButton onClick={handleSignOut} className="text-[12px]">
          Sign out
        </HGhostButton>
      }
    >
      <ShippedSummary
        email={email}
        numOfFamilies={numOfFamilies}
        shippingAddresses={shippingAddresses}
        shippingAddressAtOrder={shippingAddressAtOrder}
        nameFromServer={nameFromServer}
        phase="preparing"
      />
    </AccountPortalShell>
  );
}

export default PreparingForShipping;
